import React from "react";
import { array } from "prop-types";

import { MenuItem, func } from "../../menu-item";

import "./hamburger-two.m.css";

const HamburgerTwo = ({ hamburgerMenu, toggleHandler }) => {
  const getGridTemplate = () => {
    if (hamburgerMenu.length < 6) {
      const gridTemplateStyle = {
        "grid-template-columns": `repeat(${hamburgerMenu.length}, 1fr)`,
        "max-width": "980px",
      };
      return gridTemplateStyle;
    }
    const gridTemplateStyle = { "grid-template-columns": "repeat(6, 1fr)", width: "100%" };
    return gridTemplateStyle;
  };

  return (
    <ul styleName="wrapper" style={getGridTemplate()}>
      {hamburgerMenu.length > 0 &&
        hamburgerMenu.map((item) => {
          return (
            <li key={item.title} styleName="menu-item-wrapper">
              <div styleName="parent-menu-wrapper">
                <MenuItem menuStyle="menu-link" item={item} toggleHandler={toggleHandler} />
              </div>
              {item.children && item.children.length > 0 && (
                <ul>
                  {item.children.map((childItem) => (
                    <li key={childItem.title} styleName="child-menu-wrapper">
                      <MenuItem menuStyle="menu-link" item={childItem} toggleHandler={toggleHandler} />
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
    </ul>
  );
};

HamburgerTwo.propTypes = {
  hamburgerMenu: array,
  toggleHandler: func,
};

export default HamburgerTwo;
